// extracted by mini-css-extract-plugin
module.exports =  {"horizontal-bar-chart":"HorizontalBarChart-component-module__horizontal-bar-chart___bBg2k"};